export var PROPERTY = "trophy";
export var PADDING = 10;
export var TROPHY_SIZE = 105;
export var DEFAULT_WIDTH_OF_TROPHY_SLIDER = "538px";
export var FIXED_HEIGHT_INLINE_TROPHY_FIELD = "153px";
export var FIXED_HEIGHT_INLINE_TROPHY_FIELD_WITH_ERROR = "186px";
export var FIXED_HEIGHT_WRAPPER_TROPHY_SELECTED = "120px";
export var FIXED_HEIGHT_WRAPPER_TROPHY_NOT_SELECTED = "105px";
